import React, { Component } from 'react';

import Slider from '../../../../../../Shared/React/js/components/sliders/RangeSlider';

export default class ModalPrepaidExpirySlider extends Component {
    constructor(props) {
        super(props);

        this.lowestValue = props.values[0].key;
        this.biggestValue = props.values[props.values.length - 1].key;

        this.state = {
            initialRange: [props.minValue, props.maxValue],
            rawMinValue: null,
            rawMaxValue: null
        };

        this.handleSliderValueChanged = this.handleSliderValueChanged.bind(this);
        this.handleSliderValueUpdating = this.handleSliderValueUpdating.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return props.minValue !== state.initialRange[0] || props.maxValue !== state.initialRange[1]
            ? {
                  initialRange: [props.minValue, props.maxValue],
                  rawMinValue: null,
                  rawMaxValue: null
              }
            : null;
    }

    handleSliderValueChanged(minValue, maxValue) {
        this.props.actions.changePrepaidExpiry(minValue, maxValue);
    }

    handleSliderValueUpdating(minValue, maxValue) {
        this.setState({
            rawMinValue: minValue,
            rawMaxValue: maxValue
        });
    }

    getLabel(min, max) {
        min = min && min !== this.lowestValue ? min : this.lowestValue;

        max = max && max !== this.biggestValue ? max : this.biggestValue;

        const minValue = this.props.values.find(v => v.key === min).value;
        const maxValue = this.props.values.find(v => v.key === max).value;

        return (
            <strong>
                {minValue} - {maxValue} {this.props.resources.days}
            </strong>
        );
    }

    render() {
        const minValue = this.state.rawMinValue !== null ? this.state.rawMinValue : this.props.minValue;

        const maxValue = this.state.rawMaxValue !== null ? this.state.rawMaxValue : this.props.maxValue;

        return (
            <React.Fragment>
                <div className="font-5">Expiry: {this.getLabel(minValue, maxValue)}</div>
                <div className="rc-slider-container pad-x-3 pad-x-5-xs mar-y-2">
                    <Slider
                        data={this.props.values.map(a => a.key)}
                        minValue={minValue}
                        maxValue={maxValue}
                        onValueChanged={this.handleSliderValueChanged}
                        onValueUpdating={this.handleSliderValueUpdating}
                    />
                </div>
            </React.Fragment>
        );
    }
}
